module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de excepciones de permisos")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarSolicitud) ? _c('div', {
    key: "nueva_solicitud",
    staticClass: "box nueva-solicitud"
  }, [_c('nueva-solicitud-vacaciones', {
    attrs: {
      "is-excepcion": true
    },
    on: {
      "close": function($event) {
        _vm.mostrarSolicitud = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0e97578","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Permisos_Excepcion.vue
// module id = 942
// module chunks = 0